module.exports = __webpack_public_path__ + "static/media/smartobject_pink.f0b32a8a.png";